import firebase from "firebase";
import "@firebase/auth";
const firebaseConfig = {
  // apiKey: "AIzaSyAjQILEfaWnL-D0C0Ay2evKwfQhRpcURtk",
  // authDomain: "test-hero-6461e.firebaseapp.com",
  // databaseURL: "https://test-hero-6461e.firebaseio.com",
  // projectId: "test-hero-6461e",
  // storageBucket: "test-hero-6461e.appspot.com",
  // messagingSenderId: "521357048297",
  // appId: "1:521357048297:web:935918e50cbb711b4b7378"
  apiKey: "AIzaSyBHJBPbofn2lqZjQoedTricoMAPhvM_lBY",
  authDomain: "siampiwat-a6428.firebaseapp.com",
  projectId: "siampiwat-a6428",
  storageBucket: "siampiwat-a6428.appspot.com",
  messagingSenderId: "651953206704",
  appId: "1:651953206704:web:26a1560949315952859275"
};
export const authFirebase = firebase.initializeApp(firebaseConfig);
